import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';
import { Paragraph } from '../Paragraph';

export const StyledCard = styled(Card)`
    ${({ theme }: { theme: Theme }) => `
        position: relative;
        padding: ${theme.tggSpacing(rem(1.5), 3.75)};
        margin-bottom: ${theme.tggSpacing(rem(0.5), 1.25)};
        overflow: visible;
        color: ${theme.palette.common.blue};
        background-color: ${theme.palette.pino.standardAlternate};
        border-radius: ${theme.tggSpacing(rem(0.5), 1.25)};
        box-shadow: none;
	`}
`;

export const StyledSection = styled('span')`
    display: block;
`;

export const StyledParagraph = styled(Paragraph)`
    display: flex;
    justify-content: space-between;
`;
